'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = require('../../components/Input');

var _Input2 = _interopRequireDefault(_Input);

var _LinkButton = require('../../components/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _YellowLineSVG = require('../../svg/YellowLineSVG');

var _YellowLineSVG2 = _interopRequireDefault(_YellowLineSVG);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Title = require('./components/Title');

var _Title2 = _interopRequireDefault(_Title);

var _Subtitle = require('./components/Subtitle');

var _Subtitle2 = _interopRequireDefault(_Subtitle);

var _SearchWrapper = require('./components/SearchWrapper');

var _SearchWrapper2 = _interopRequireDefault(_SearchWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
# SearchCTA
A CTA containing a search bar.
 */
var SearchCTA = function (_React$Component) {
  _inherits(SearchCTA, _React$Component);

  function SearchCTA(props) {
    _classCallCheck(this, SearchCTA);

    // fallback for if prop is passed but is empty string
    var _this = _possibleConstructorReturn(this, (SearchCTA.__proto__ || Object.getPrototypeOf(SearchCTA)).call(this, props));

    _this.searchPage = props.buttonLink || '/search';

    _this.state = {
      searchTerm: _this.searchPage + '?search={"keyword":""}'
    };

    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleKeyPress = _this.handleKeyPress.bind(_this);
    return _this;
  }

  _createClass(SearchCTA, [{
    key: 'handleInputChange',
    value: function handleInputChange(event) {
      this.setState({
        searchTerm: this.searchPage + '?search={"keyword":' + JSON.stringify(event.target.value) + '}'
      });
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(e) {
      if (e.charCode === 13) {
        window.location.assign(this.state.searchTerm);
      }

      return undefined;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          subTitle = _props.subTitle,
          buttonLabel = _props.buttonLabel;


      return _react2.default.createElement(
        _Wrapper2.default,
        null,
        _react2.default.createElement(_YellowLineSVG2.default, null),
        _react2.default.createElement(
          _Title2.default,
          null,
          title
        ),
        _react2.default.createElement(
          _Subtitle2.default,
          null,
          subTitle
        ),
        _react2.default.createElement(
          _SearchWrapper2.default,
          null,
          _react2.default.createElement(_Input2.default, {
            onChange: this.handleInputChange,
            onKeyPress: this.handleKeyPress,
            placeholder: 'Add Keyword'
          }),
          _react2.default.createElement(
            _LinkButton2.default,
            {
              href: this.state.searchTerm
            },
            buttonLabel
          )
        )
      );
    }
  }]);

  return SearchCTA;
}(_react2.default.Component);

SearchCTA.propTypes = {
  /** the title. */
  title: _propTypes2.default.string.isRequired,
  /** the subtitle. */
  subTitle: _propTypes2.default.string.isRequired,
  /** the label text for the button. */
  buttonLabel: _propTypes2.default.string.isRequired,
  /** the base URL for the search page to use. */
  buttonLink: _propTypes2.default.string
};

SearchCTA.defaultProps = {
  buttonLink: '/search'
};

SearchCTA.displayName = 'SearchCTA';

exports.default = SearchCTA;
SearchCTA.__docgenInfo = {
  'description': '# SearchCTA\r\nA CTA containing a search bar.',
  'methods': [{
    'name': 'handleInputChange',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'event',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'handleKeyPress',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'e',
      'type': null
    }],
    'returns': null
  }],
  'displayName': 'SearchCTA',
  'props': {
    'buttonLink': {
      'defaultValue': {
        'value': '\'/search\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'the base URL for the search page to use.'
    },
    'title': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'the title.'
    },
    'subTitle': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'the subtitle.'
    },
    'buttonLabel': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'the label text for the button.'
    }
  }
};